import { DashboardPage } from "@dashboard/features/Dashboard/DashboardPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/dashboard/$profileId/")({
    component: RouteComponent,
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    const { customerId, profileId } = Route.useParams();

    return <DashboardPage customerId={customerId} profileId={Number(profileId)} />;
}
